export const getUserList = (state) => {
  return state.userList;
};

export const getShowTerminatedUsers = (state) => {
  const { showTerminatedUsers } = getUserList(state);
  return showTerminatedUsers;
};

export const getShowUserEntryModal = (state) => {
  const { showUserEntryModal } = getUserList(state);
  return showUserEntryModal;
};
